import { all, fork, put, takeLatest, call } from 'redux-saga/effects';
import * as actionTypes from 'appRedux/actions/insight/insightActionType';
import * as actionCreators from 'appRedux/actions/insight';
import { API_URL_V1, API_PMS_HEADERS } from 'constants/ApiSetting';
import { APIPostRequest } from 'util/connection';
import { getItems } from 'util/localStorage';
import { ApiResponse } from 'constants/ActionTypes';
import { userSignOut } from 'appRedux/actions/Auth';

function* reservationPickupProcess({ payload }: actionTypes.InsightReservationPickupRequest) {
  try {
    const { access_token } = yield call(getItems, ['access_token']);
    API_PMS_HEADERS.headers.Authorization = `Bearer ${access_token}`;

    const url = `${API_URL_V1}pms/rpc/insight/reservation_pickup`;
    const response: ApiResponse = yield APIPostRequest(url, payload, API_PMS_HEADERS);

    if (response.status === 200) {
      const data = response.data?.result_data ?? [];
      yield put({ type: actionTypes.INSIGHT_RESERVATION_PICKUP_SUCCESS, payload: Array.isArray(data) ? data : [] });
    } else {
      const { message, data } = response.data || {};
      yield put(actionCreators.insightProcessSuccess({ status: false, action: 'reservationPickup', message: message || 'Error' }));
      if (response.status === 403) yield put(userSignOut());
    }
  } catch (error: any) {
    yield put(actionCreators.insightProcessSuccess({ status: false, action: 'reservationPickup', message: String(error) }));
  }
}

function* bookingPaceProcess({ payload }: actionTypes.InsightBookingPaceRequest) {
  try {
    const { access_token } = yield call(getItems, ['access_token']);
    API_PMS_HEADERS.headers.Authorization = `Bearer ${access_token}`;

    const url = `${API_URL_V1}pms/rpc/insight/booking_pace`;
    const response: ApiResponse = yield APIPostRequest(url, payload, API_PMS_HEADERS);

    if (response.status === 200) {
      yield put({ type: actionTypes.INSIGHT_BOOKING_PACE_SUCCESS, payload: response.data?.result_data ?? null });
    } else {
      const { message, data } = response.data || {};
      yield put(actionCreators.insightProcessSuccess({ status: false, action: 'bookingPace', message: message || 'Error' }));
      if (response.status === 403) yield put(userSignOut());
    }
  } catch (error: any) {
    yield put(actionCreators.insightProcessSuccess({ status: false, action: 'bookingPace', message: String(error) }));
  }
}

function* productivityProcess({ payload }: actionTypes.InsightProductivityRequest) {
  try {
    const { access_token } = yield call(getItems, ['access_token']);
    API_PMS_HEADERS.headers.Authorization = `Bearer ${access_token}`;

    const url = `${API_URL_V1}pms/rpc/insight/productivity`;
    const response: ApiResponse = yield APIPostRequest(url, payload, API_PMS_HEADERS);

    if (response.status === 200) {
      const data = response.data?.result_data ?? [];
      yield put({ type: actionTypes.INSIGHT_PRODUCTIVITY_SUCCESS, payload: Array.isArray(data) ? data : [] });
    } else {
      const { message, data } = response.data || {};
      yield put(actionCreators.insightProcessSuccess({ status: false, action: 'productivity', message: message || 'Error' }));
      if (response.status === 403) yield put(userSignOut());
    }
  } catch (error: any) {
    yield put(actionCreators.insightProcessSuccess({ status: false, action: 'productivity', message: String(error) }));
  }
}

function* watchReservationPickup() {
  yield takeLatest(actionTypes.INSIGHT_RESERVATION_PICKUP_REQUEST, reservationPickupProcess);
}

function* watchBookingPace() {
  yield takeLatest(actionTypes.INSIGHT_BOOKING_PACE_REQUEST, bookingPaceProcess);
}

function* watchProductivity() {
  yield takeLatest(actionTypes.INSIGHT_PRODUCTIVITY_REQUEST, productivityProcess);
}

export default function* insightSaga() {
  yield all([fork(watchReservationPickup), fork(watchBookingPace), fork(watchProductivity)]);
}
